import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

    }

	toggle(e) {
		if(e.mode == 'enter') {
			let notifications = document.querySelectorAll('[data-module-notification]');
			notifications.forEach(item => {
				item.classList.remove('is-active');
			});
			
			this.el.classList.add('is-active');
		} else {
			this.el.classList.remove('is-active');
		}
	}

	removeAllNotifications() {
		let notifications = document.querySelectorAll('[data-module-notification]');
		notifications.forEach(item => {
			item.classList.remove('is-active');
		});
	}
}
